import React from 'react'
import './benefit.css'

const Benefit = () => {
  return (
    <div className='benefit-container'>
      <div className='container'>
        <div className='benefit-heading'>
          <h4>Benefits of a CRM Software </h4>
        </div>
        <div className="benefits-row">
          <div className="benefits-box">
            <h3>300%</h3>
            <p>
              Improvement in lead <br/> conversion rates
            </p>
          </div>
          <div className="benefits-box">
            <h3>41%</h3>
            <p>
              Revenue increase per <br/> sales person
            </p>
          </div>
          <div className="benefits-box">
            <h3>26%</h3>
            <p>
              Improvement in customer <br/> retention rates
            </p>
          </div>
          <div className="benefits-box">
            <h3>47%</h3>
            <p>
              Increase in customer <br/> satisfaction  rate
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Benefit
